/** 活动中心 */
// 签到活动列表查询
export const SIGN_ACTIVITY_LIST = '/cmvip/signActivity/list';
// 修改签到活动
export const SIGN_ACTIVITY_UPDATE = '/cmvip/signActivity/update';
// 签到活动列表更新状态
export const SIGN_ACTIVITY_UPDATESTATUS = '/cmvip/signActivity/updateStatus';
// 添加签到活动
export const SIGN_ACTIVITY_ADD = '/cmvip/signActivity/add';
// 签到活动详情查询
export const SIGN_ACTIVITY_DETAIL = '/cmvip/signActivity/detail';
